export default {
  id: '',
  firstName: '',
  lastName: '',
  username: '',
  updatedBy: '',
  branchCode: '',
  accessLevel: '',
};
